import { PureComponent } from "react"

class PreventScroll extends PureComponent {
  componentDidMount() {
    document.body.style.overflow = "hidden"
  }
  render() {
    return null
  }
}

export default PreventScroll



// WEBPACK FOOTER //
// ./src/components/prevent-scroll/prevent-scroll.component.js